const useComponentPresetProp = {
  preset: {
    type: String,
    default: void 0
  }
};
export { useComponentPresetProp as u };
//# sourceMappingURL=useComponentPreset.js.map
